var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order-detail-invalid d-flex flex-column scroll-container"},[_c('v-container',{staticClass:"d-flex flex-column scroll-container",attrs:{"fluid":""}},[_c('h1',[_vm._v(_vm._s(_vm.$t("orders.anon.invalid.title")))]),_c('p',[_vm._v(_vm._s(_vm.$t("orders.anon.invalid.description")))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }